import Typography from '@mui/material/Typography';
import { BarChart, BarChartProps } from '@mui/x-charts/BarChart';

const translations = {
    goals: 'Goal',
    assists: 'Assist',
    assiststotal: 'Assists Total',
    goalstotal: 'Goals Total',
    totalPts: 'Total Points',
} as const;
    
function addLabels<T extends { dataKey: keyof typeof translations }>(series: T[]) {
    return series.map((item) => ({
      ...item,
      label: translations[item.dataKey],
    }));
  }

export default function StackBars({chartData}: {chartData: any}) {

    const filteredChartData = chartData?.map(({goals, assists, shots, pim }) => ({
        goals,
        assists,
        shots,
        pim,
      }));    
      
    const combinedChartData = [];
        let runningTotalAssists = 0;
        let runningTotalGoals = 0;
        let i = 0;
        filteredChartData?.forEach(item => {
            const totalGoal = (item.goals || 0);
            const totalAssist = (item.assists || 0);
            runningTotalAssists += totalAssist;
            runningTotalGoals += totalGoal;
            combinedChartData.push({
            ...item,
            assiststotal: runningTotalAssists,
            goalstotal: runningTotalGoals,
            totalPts: runningTotalGoals+runningTotalAssists,
            game: i + 1,
            });
            i++;
      });

    console.log(combinedChartData);

  return (
    <div style={{ width: '100%' }}>
      <Typography style={{color: 'black', fontWeight: '900'}}>Goal and Points per games</Typography>
      <BarChart
        dataset={combinedChartData}
        series={addLabels([
          { dataKey: 'totalPts', stack: 'totalLabel', color: '#f1f1f1', label: 'Total Points',  },
          { dataKey: 'assiststotal', stack: 'total', barWidth: 10, },
          { dataKey: 'goalstotal', stack: 'total', barWidth: 10,  },    
          { dataKey: 'goals', stack: 'pts', barWidth: 10, },
          { dataKey: 'assists', stack: 'pts', barWidth: 10, },     
        ])}
        xAxis={[{ dataKey: 'game',
        barGapRatio: -0.75,
        categoryGapRatio: 0.01,
         }]}
        {...config}
      />
    </div>
  );
}

const config: Partial<BarChartProps> = {
    height: 350,
    margin: { left: 0 },
    yAxis: [{ width: 35, min: 0 }],
    hideLegend: false,
};